// What the site says about the company itself: its name and how to reach it.
// Deliberately nothing more — no registration numbers or addresses.
export const company = {
  legalName: "Madarion",
  email: "contact@madarion.com",
  privacyUpdated: "2026-09-27",
};
